import { Popper, Tooltip } from "@mui/material";
import { BarChart, Plus, Minus, TrendingDown, TrendingUp } from "lucide-react";
import React from "react";
import amplitude from "../../utils/ampli";
import { useEffect } from "react";
import ColorChangingText from "./colorChangingText";
import RapChangeGrading from "../newTable/cellComponents/rapChangeGrading";
import AnimatedText from "./colorChangingText";
import {sortByMapping, TimeSince, cn, formatter} from "../../utils/utils";
import { useDispatch } from "react-redux";
import { LuInfo } from "react-icons/lu";
const GradingChip = ({ rapnetData,metaTags, isFiltered, recoData, confidence, configSort, mappedItem,setCurrentPage,setMarketFrom,setIsSold,isSold }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMouseOver = (event) => {
    event.stopPropagation();

    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleMouseOut = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  }; 
  
  function roundIfFloat(value) {
          // Check if the value is a number and if it has a decimal part
          if (typeof value === 'number' && value % 1 !== 0) {
            // Round the number to 2 decimal places
            return Math.round(value * 100) / 100;
          }
          // Return the value as it is if it's not a float
          return value;
    }

  // write a function to return number with one decimal place for any given number or integer
  function roundToZeroDecimal(value) {
        return (Math.round(value * 10) / 10).toFixed(0);
  }           

  const open = Boolean(anchorEl);
  const dispatch = useDispatch()
  const handleClick = () => {
    // setCurrentPage(1);
    // setMarketFrom(0);
    setIsSold(true);
  };
    

  useEffect(() => {
    if (open) {
      // amplitude events.
      const buttonClickedEvent = {
        event_type: `v2_itemDetails_grading_active`,
      };
      amplitude.track(buttonClickedEvent);
    }
  }, [open]);

  const getBgColor = (value) => {
    if (!value) return "#FFF1EB";

    if (value.toLowerCase() == "high") {
      return "#EBFFF3";
    } else if (value.toLowerCase() == "medium") {
      return "#FFFDEB";
    } else if (value.toLowerCase() == "low") {
      return "#FFF1EB";
    }
  };
  const parseNumber = (input) => {
      if (input === null || input === undefined || input === "") return null;
      const numeric = Number(input);
      return Number.isFinite(numeric) ? numeric : null;
    };
  
  const postionColor = (input) =>{
    const pct = parseNumber(input);

    if (
      pct === null
    ) {
      return {
        label: input ?? "-",
        colorClass: "text-gray-700 border-gray-300 bg-gray-50",
        Icon: null,
      };
    }

    

    if (!Number.isFinite(pct) || Math.abs(pct) == 0) {
      return {
        label: "Inside",
        colorClass: "text-green-700 border-green-300 bg-green-50",
        Icon: null,
      };
    }

    if (pct > 0) {
      return {
        label: `${pct.toFixed(0)}%`,
        colorClass: "text-amber-700 border-amber-300 bg-amber-50",
        Icon: TrendingUp,
      };
    }

    return {
      label: `${Math.abs(pct).toFixed(0)}%`,
      colorClass: "text-red-600 border-red-300 bg-red-50",
      Icon: TrendingDown,
    };
  }  

  const getConfidenceBadgeClass = (confidenceValue) => {
    const normalizedConfidence =
      typeof confidenceValue === "string"
        ? confidenceValue.trim().toLowerCase()
        : "";

    return cn(
      "text-[0.6rem] px-2 py-0.5 rounded-full border font-semibold capitalize inline-flex items-center justify-center min-w-[40px]",
      normalizedConfidence.startsWith("high") &&
        "bg-green-50 text-green-700 border-green-300",
      normalizedConfidence.startsWith("med") &&
        "bg-amber-50 text-amber-700 border-amber-300",
      normalizedConfidence.startsWith("low") &&
        "bg-red-50 text-red-700 border-red-300",
      !normalizedConfidence && "bg-gray-50 text-gray-600 border-gray-300"
    );
  }  

  const rapKeys = ["1st", "5th", "10th", "25th", "50th", "100th"];

  const rankKeys = ["Rap Rank", "Rap Matching count"];

  const suggestedConfidenceValue = mappedItem?.["Confidence"];
  const suggestedConfidenceLabel = suggestedConfidenceValue ?? "-";
  const positionMeta = postionColor(mappedItem?.["Position"]);

  const renderCellContent = (key, value, filteredCount) => {
    switch (key) {
      case "count":
        return <AnimatedText key={key} text={metaTags.count} />;
      case "Rank Change":
        return <RapChangeGrading diffValue={value} threshold={5} />;
        case "Sold":
          return (
            <p onClick={handleClick} key={key} className="cursor-pointer hover:text-blue-600">
              {value ?? "Sold"}
            </p>
          );        
      default:
        return value;
    }
  };
  return (
    <>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
        className="!z-[1000]"
      >
        <div className="flex flex-col gap-2 border border-[#cbcbcb] rounded-xl px-2 py-2 bg-white ">
        
          <div className="flex text-xs justify-between gap-2">

            
              {rankKeys.map((key) => {
                const previousValue =
                  key === "Rap Rank"
                    ? mappedItem[key] - mappedItem["Rap Rank Diff"]
                    : mappedItem[key] - mappedItem["Rap Count Diff"];
                const currentValue = mappedItem[key];

                if (previousValue == null || currentValue == null) {
                  return null;
                }
                const isCountMovement = (key === "Rap Matching count");
                if (isCountMovement){
                  return(
                    <div className="grading-inventory-info bg-white">
                      <h5>Market Movement</h5>
                      <p className="text-gray-500 pholder w-44 text-[0.67rem] tracking-normal font-medium leading-[0.76875rem] ">Stones entered or left the market based on the search criteria</p>
                      <br />
                      <p><strong>{previousValue}</strong> stones (<TimeSince dateString={mappedItem.trackingDate} /> ago)</p>
                      <p><strong>{currentValue}</strong> stones (Now)</p>
                      <div className="change-info">
                        <p className="added  flex justify-between items-center">
                          <Plus className="p-1" direction="-1" color="green" />{mappedItem["Supply Count"]} added
                        </p>
                        <p className="sold flex justify-between items-center">
                          <Minus className="p-1" direction="1" color="red" />{mappedItem["Demand Count"]} sold
                        </p>
                      </div>
                    </div>
                  )
                } else {
                  return(
                    <div className="grading-inventory-info bg-white">
                      <h5>Rank Movement</h5>
                      <p className="pholder text-gray-500 w-44 text-[0.67rem] font-medium tracking-normal leading-[0.76875rem]">Your ranking is based on the search criteria's in the market</p>  
                      <br />
                      <p><strong>{previousValue}</strong> stones (<TimeSince dateString={mappedItem.trackingDate} /> ago)</p>
                      <p><strong>{currentValue}</strong> stones (Now)</p>
                    </div>
                  )
                }
              })}
          </div>

     

       
          {/* <div className="flex px-3 py-2 gap-4 justify-center border border-[#cbcbcb] rounded-xl">
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Band Range
            </div>
            <div className="text-xs text-right font-normal mt-[0.1rem] text-gray-400">
              {(mappedItem["PPC Predicted From"] && mappedItem["PPC Predicted To"]) ? `${formatter.format(Math.round(mappedItem["PPC Predicted From"]))}-${formatter.format(Math.round(mappedItem["PPC Predicted To"]))}` : '-'}
            </div>
          </div>
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Suggested Price
            </div>
            <div className="text-xs text-center mt-[0.1rem] font-normal text-gray-400">
              {mappedItem["Suggested Price"] !== null && mappedItem["Suggested Price"] != 0 ? formatter.format(Math.round(mappedItem["Suggested Price"])) : '-'}
            </div>
          </div>
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Confidence
            </div>
            <div className="text-[0.65rem] text-center mt-[0.1rem] font-normal text-gray-400">
            {
              (mappedItem["Suggested Price"] !== null || mappedItem["PPC Predicted From"] !== null || mappedItem["PPC Predicted To"] !== null) ?(
                <p className={getConfidenceBadgeClass(suggestedConfidenceValue)}>
                {suggestedConfidenceLabel}
              </p>
               ) : "-"
            }
            </div>
          </div>
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Position
            </div>
            <div className="text-[0.65rem] font-normal mt-[0.1rem] text-gray-400">
            {(mappedItem["Suggested Price"] !== null || mappedItem["PPC Predicted From"] !== null || mappedItem["PPC Predicted To"] !== null) ? (
              <p
                className={cn(
                  "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[0.6rem] font-semibold",
                  positionMeta.colorClass
                )}
              >
                {positionMeta.Icon ? (
                  <positionMeta.Icon size={12} strokeWidth={2} />
                ) : null}
                {positionMeta.label}
              </p>
            ) : "-"}
              
            </div>
          </div>
        </div> */}

         
        <div className="flex  py-2  justify-between border border-[#CBCBCB] rounded-xl ">
          <div className="flex justify-center items-center mx-auto">
          {configSort == "rap_discount" ? (
               <div className="flex flex-col justify-center mr-2" key={"Reco Rap"}>
                      <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
                        Repl Rap
                      </div>
                      <div className="text-xs  font-normal text-gray-400">
                        {mappedItem["Reco Rap"] || "-"}
                      </div>
              </div>
          ):(configSort == "price_per_carat" ? (
              <div className="flex flex-col justify-center mr-2" key={"Reco PPC"}>
                      <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
                        Repl PPC
                      </div>
                      <div className="text-xs  font-normal text-gray-400">
                        { mappedItem["Reco PPC"] ? ("$" + mappedItem["Reco PPC"]?.toFixed(0)) : "-"}
                      </div>
              </div>
          ): ( configSort == "total_price" &&
           (<div className="flex flex-col justify-center mr-2" key={"Repl Total"}>
                      <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
                        Repl Total
                      </div>
                      <div className="text-xs  font-normal text-gray-400">
                        {(mappedItem["Reco PPC"] * mappedItem["Carat"])?.toFixed(0) || "-"}
                      </div>
              </div>)
          ))}    
​          </div>

          <div className="flex items-center justify-center mx-auto">
          <BarChart
            height={"14px"}
            className="mr-1 cursor-pointer self-center"
          />
              {rapKeys.map((key) => {
                if (rapnetData[key] !== null && rapnetData[key] ) {
                  return (
                    <div className="flex flex-col justify-center mr-2" key={key}>
                      <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
                        {key}
                      </div>
                      <div className="text-xs  font-normal text-gray-400">
                        {rapnetData[key]}
                      </div>
                    </div>
                  );
                } else {
                  return; 
                }
              })}
           </div>   
        </div>
         
        {/* Turn, Needs, Needs/Surplus, Overhang Section */}
        <div className="flex px-3 py-2 gap-4 justify-center border border-[#cbcbcb] rounded-xl">
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Turn
            </div>
            <div className="text-xs text-right font-normal mt-[0.1rem] text-gray-400">
              {mappedItem.Turn ? `${mappedItem.Turn.toFixed(1)}x` : '-'}
            </div>
          </div>
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Needs
            </div>
            <div className="text-xs text-center mt-[0.1rem] font-normal text-gray-400">
              {mappedItem.Needs !== null ? roundToZeroDecimal(Math.floor(mappedItem?.Needs)) : '-'}
            </div>
          </div>
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Needs/Surplus
            </div>
            <div className={`px-2 pb-[0.15rem] rounded-full w-max text-[0.7rem] text-center font-semibold ${mappedItem["Needs/Surplus"] == 'needs' ? 'bg-green-100 text-green-800' : mappedItem["Needs/Surplus"] == 'surplus' ? 'bg-red-100 text-red-800' : ""}`}>
              {mappedItem["Needs/Surplus"] || '-'}
            </div>
          </div>
          <div className="flex flex-col justify-center mr-2">
            <div className="text-[0.66rem] flex justify-center mx-auto items-start font-bold text-gray-700">
              Overhang
            </div>
            <div className="text-xs font-normal mt-[0.1rem] text-gray-400">
              {mappedItem.Overhang ? `${mappedItem.Overhang.toFixed(0)} days` : '-'}
            </div>
          </div>
        </div>

       
        
      </div>
       
      </Popper>
      <div
        className=" bottom-0 px-3 py-1  bg-[#EEEEEE] rounded-xl overflow-visible flex gap-2 justify-center z-[100000] cursor-pointer "
        onMouseEnter={handleMouseOver}
        onMouseLeave={handleMouseOut}
        style={{
          backgroundColor: getBgColor(
            confidence ? confidence.toLowerCase() : null
          ),
        }}
      >
        {rapnetData
          ? Object.entries(rapnetData).map(([key, value]) => {
            
              if ( key.toLowerCase() == "1st" ) {
                return;
              }

              if ( key.toLowerCase() == "filteredcount" ) {
                return;
              }

              if (value == null) {
                return;
              }

              if (!rapKeys.includes(key.toLowerCase())) {
                if (key == "3rd") {
                  return;
                }
                let keyToDisplay = key === "rank" ? `${key.toUpperCase()} by ${sortByMapping[configSort]}` : key.toUpperCase();
                {/* return isFiltered && (key == "rank") ? ( */}

                return (key == "rank") ? (
                  
                  <div
                    className="flex flex-col justify-center items-center"
                    key={key}
                  >
                    <div className="text-[0.66rem] font-bold text-gray-700">
                      {keyToDisplay} 
                    </div>
                    <div className="text-sm font-normal text-gray-400 flex ">
                      {/* <AnimatedText text={value} /> /{rapnetData.filteredCount} */}
                      <AnimatedText text={metaTags.rank} />
                    </div>
                  </div>
                ) : (
                  <div
                    className="flex flex-col justify-center items-center"
                    key={key}
                  >
                    <div className="text-[0.66rem] font-bold text-gray-700 flex items-center gap-[0.1rem]">
                      {keyToDisplay} {key == "Sold" ?<Tooltip placement="top" title="Click on sold count to view details"> <LuInfo className="text-[0.66rem] mb-1 font-bold text-gray-900 w-[0.64rem] h-[0.64rem]" /></Tooltip>: <></>}
                    </div>
                    <div className="text-xs font-normal text-gray-400">
                     {renderCellContent(key, value, rapnetData.filteredCount)}
                      
                    </div>
                  </div>
                );
              }
            })
          : ""}
      </div>
    </>
  );
};

export default GradingChip;